import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo-centrao.png';

// Exibe o CPF mascarado (123.456.789-00) enquanto o usuário digita; guardamos só dígitos.
function formatarCpf(digitos) {
  const d = digitos.replace(/\D/g, '').slice(0, 11);
  if (d.length > 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  if (d.length > 6) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  if (d.length > 3) return `${d.slice(0, 3)}.${d.slice(3)}`;
  return d;
}

export default function Login() {
  const [cpf, setCpf] = useState(''); // só dígitos
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      const usuario = await login(cpf, senha);
      navigate(usuario.precisa_trocar_senha ? '/trocar-senha' : '/');
    } catch (err) {
      setErro(err.response?.data?.error || 'Não foi possível entrar');
    } finally {
      setCarregando(false);
    }
  }

  return (
    <div className="login-bg">
      <form className="login-card" onSubmit={onSubmit}>
        <img src={logo} alt="Centrão" className="logo" />
        <h1>Portal do Colaborador</h1>
        <p className="subtitle">Bem-vindo ao Centrão</p>

        {erro && <div className="erro">{erro}</div>}

        <label htmlFor="cpf">CPF</label>
        <input
          id="cpf"
          type="text"
          inputMode="numeric"
          autoComplete="username"
          placeholder="000.000.000-00"
          value={formatarCpf(cpf)}
          onChange={(e) => setCpf(e.target.value.replace(/\D/g, '').slice(0, 11))}
          autoFocus
          required
        />

        <label htmlFor="senha">Senha</label>
        <input
          id="senha"
          type="password"
          autoComplete="current-password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          required
        />

        <button type="submit" className="btn-centrao w-100" disabled={carregando}>
          {carregando ? 'Entrando…' : 'Entrar'}
        </button>

        <p className="subtitle" style={{ marginTop: 16, fontSize: 13 }}>
          Primeiro acesso? Sua senha são os <strong>6 primeiros dígitos do seu CPF</strong>.
        </p>
      </form>
    </div>
  );
}
